// PATH
export const SOCKET_PATH = '/careontel-socket-server';

//Namespace(nsp) for web
export const NAMESPACE_WEB = '/web';
//Namespace(nsp) for chat
export const NAMESPACE_CHAT = '/chat';
//Namespace(nsp) for custom-chat
export const NAMESPACE_CUSTOM_CHAT = '/custom-chat';
//Namespace(nsp) for video-consultation
export const NAMESPACE_VIDEO_CONSULTATION = '/videoconsultation';

/**
 * Event
 */

// EVENT -  CONNECTE
export const CONNECTE = 'connect';

// EVENT -  DISCONNECTED
export const DISCONNECTED = 'disconnect';
// EVENT - CONNECT ERROR
export const CONNECT_ERROR = 'connect_error';
// EVENT - CONNECT TIMEOUT
export const CONNECT_TIMEOUT = 'connect_timeout';
// EVENT - SOCKET CONNECTED
export const SOCKET_CONNECTED = 'socket_connected';
// EVENT - SOCKET CONNECTED
export const SOCKET_DISCONNECTED = 'socket_disconnected';
// EVENT - WRONG INFORMATION
export const WRONG_INFORMATION = 'wrong_information';

/**
 * EMIT
 */
// EMIT - ON DOCTOR CONNECT
export const EMIT_ON_DOCTOR_CONNECT = 'on_doctor_connect';
export const EMIT_ON_CLASSROOM_CONNECT = 'classroom_init';

/**
 * Types
 */
//TYPE -  VIDEO CALL CONNECTED
export const VIDEO_CALL_CONNECTED = 'video_call_connected';

/**
 * Types
 */
//TYPE -  PATIENT CALL INITIATION
export const PATIENT_CALL_INITIATION = 'patient_call_initiation';

export const VIDEO_CONSULTATION_REJOIN = 'rejoin_video_consultation';

export const VIDEO_CONSULTATION_LEFT = 'left_video_consultation';

//TYPE -  ENDED CALL
export const ENDED_CALL = 'ended_call';
//TYPE -  ON MESSAGE
export const ON_MESSAGE = 'on_message';
//TYPE -  PATIENT CALL INITIATION
export const EMIT_ON_SEND_MESSAGE = 'on_send_message';
// custom-chat send messages
export const EMIT_ON_CUSTOM_SEND_MESSAGE = 'on_chat_send_message';
export const ON_CHAT_MESSAGE = 'on_chat_message';
export const UN_UNREAD_COUNT = 'un_read_count';
export const ON_CHAT_MESSAGE_READ = 'custom_chat_read';
export const ON_TYPING = 'on_typing';
export const ON_CHAT_OPENED="chat_opened"


// White-Board
export const EMIT_ON__WHITEBOARD_SEND_MESSAGE = 'on_white_board_send_message';
export const EMIT_ON__WHITEBOARD_OPEN = 'on_white_board_open_send_message';
export const ON_WHITEBOARD_MESSAGE = 'on_white_board_message';
export const ON_WHITEBOARD_OPEN = 'on_white_board_open';
export const WHITEBOARD_OPEN_MESSAGE = 'whiteboard_open_message';
export const WHITEBOARD_FILE = 'on_white_board_file';

// Stream ID and Live Captions
// EMIT events (what client sends to server)
// export const EMIT_STREAM_ID_CREATED = 'emit_stream_id_created';
// export const EMIT_LIVE_CAPTION = 'emit_live_caption';
// // RECEIVE events (what server broadcasts to clients)
// export const ON_STREAM_ID_CREATED = 'on_stream_id_created';
// export const ON_LIVE_CAPTION = 'on_live_caption';

export const EMIT_STREAM_ID_CREATED = 'on_stream_id_created';
export const EMIT_LIVE_CAPTION = 'on_live_caption';
// RECEIVE events (what server broadcasts to clients)
export const ON_STREAM_ID_CREATED = 'on_stream_id_created';
export const ON_LIVE_CAPTION = 'on_live_caption';

/* ----- Patient Chat nsp type of Listener--- */

//TYPE -   DOCTOR CONNECTED
export const DOCTOR_CONNECTED = 'doctor_connected';
//TYPE -   DOCTOR CONNECTED
export const DOCTOR_DISCONNECTION = 'doctor_disconnection';
//TYPE -    DOCTOR BUSY
export const DOCTOR_BUSY = 'doctor_busy';
//TYPE -   DOCTOR END CALL
export const DOCTOR_END_CALL = 'call_end_by_physician';

/* ----- Doctor Chat nsp type of Listener---     */
//TYPE -   PATIENT DISCONNECTION
export const PATIENT_CONNECTED = 'patient_connected';

//TYPE -   PATIENT CONNECTED
export const PATIENT_DISCONNECTION = 'patient_disconnection';

//TYPE -    PATIENT BUSY
export const PATIENT_BUSY = 'patient_busy';

// //TYPE -    PATIENT END CALL
// export const   PATIENT_END_CALL = 'call_end_by_patient';

// //TYPE -    ON PATIENT END CALL
export const ON_PATIENT_CALL_END = 'on_patient_call_end';

//TYPE -    PATIENT END CALL
export const PATIENT_CALL_END = 'patient_call_end';

/**
 * SOCKET IO - TYPE -  ON PHYSICIAN CAMERA OFF
 */
export const ON_PHYSICIAN_CAMERA_OFF = 'on_physician_camera_off';

/**
 * SOCKET IO - TYPE -  ON PHYSICIAN CAMERA ON
 */
export const ON_PHYSICIAN_CAMERA_ON = 'on_physician_camera_on';

/**
 * SOCKET IO - TYPE -  ON PHYSICIAN CAMERA ON
 */
export const PHYSICIAN_CAMERA_ON = 'physician_camera_on';

/**
 * SOCKET IO - TYPE -  ON PHYSICIAN CAMERA OFF
 */
export const PHYSICIAN_CAMERA_OFF = 'physician_camera_off';

/**
 * SOCKET IO - TYPE - NEW ONDEMAND BOOKED
 */
export const NEW_ONDEMAND_BOOKED = 'new_ondemand';

/**
 * SOCKET IO - TYPE - NEW APPOINTMENT BOOKED
 */
export const NEW_APPOINTMENT_BOOKED = 'new_appointment';

export const NOTIFICATION_COUNT = 'notification_count';

export const INACTIVE_USER = 'user_inactive_notification';

export const DASHBOARD_APPOINTMENT = 'Dashboard_refreshing';

export const LIVE_STREAM_STARTED = 'livestreaming_started';

export const MEETING_SUMMARY = 'MEETING_SUMMARY';

export const STUDENT_PARTICIPATION_LIST = 'student_participation_list';

export const EDUCATOR_MUTE_MESSAGE = 'educator_mute_message';

export const ANONYMOUS_USER_DETAILS = "anonymous_user_details"

export const ANONYMOUS_USER_CONNECTED = "anonymous_user_connected";

export const ANONYMOUS_USER_DISCONNECTION = "anonymous_user_disconnection"

export const NEW_SESSION_DETAILS = "new_session_details";